import Vue from 'vue';
import Vuex from 'vuex';
import RoutePage from './module/route-page';
import Hundun from './module/hundun';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    RoutePage,
    Hundun,
  },
});
